Alpine.data('SevenCRMCheckoutFormAddress', (element) => ({
	value: {
		firstName: '',
		lastName: '',
		street: '',
		streetNumber: '',
		zipCode: '',
		city: '',
		email: '',
		phone: '',
		country: ''
	},

	setCountry(country) {
		this.value.country = country;
	},

	initAutoComplete(el, provider, apiKey) {
		if (provider === 'googlePlaces') {
			this._initAutoCompleteForGooglePlaces(el);
		}
		if (provider === 'getAddressIo') {
			this._initAutoCompleteForGetAddressIo(el, apiKey);
		}
	},

	_initAutoCompleteForGetAddressIo(el, apiKey) {
		getAddress.autocomplete(el.id, apiKey, {
			list_class_names: ['list-group'],
			suggestion_class_names: ['list-group-item']
		});

		document.addEventListener('getaddress-autocomplete-address-selected', (e) => {
			this._dispatchEvent('selected');

			if (e.address.line_1) {
				this.value.street = e.address.line_1;
			}
			if (e.address.postcode) {
				this.value.zipCode = e.address.postcode;
			}
			if (e.address.town_or_city) {
				this.value.city = e.address.town_or_city;
			}
			e.preventDefault();
		});
	},

	_initAutoCompleteForGooglePlaces(el) {
		let autocomplete = new google.maps.places.Autocomplete(el, {
			componentRestrictions: {country: [this.value.country]},
			fields: ['address_components'],
			types: ['address']
		});

		el.placeholder = '';

		autocomplete.addListener('place_changed', () => {
			this._dispatchEvent('selected');
			const place = autocomplete.getPlace();

			let street = '';
			let streetNumber = '';

			for (const component of place.address_components) {
				const componentType = component.types[0];

				switch (componentType) {
					case 'route': {
						street = component.long_name;
						break;
					}
					case 'street_number': {
						streetNumber = component.long_name;
						break;
					}
					case 'postal_code': {
						this.value.zipCode = component.long_name;
						break;
					}
					case 'postal_town':
					case 'locality': {
						this.value.city = component.long_name;
						break;
					}
				}
			}

			if (street && streetNumber) {
				this.value.street = streetNumber + ' ' + street;
			} else {
				this.value.street = street;
			}
		});
	},

	_dispatchEvent(name, {cancelable, bubbles, ...detail} = {}) {
		return document.dispatchEvent(new CustomEvent(`seven:checkout:address:${name}`, {
			detail,
			bubbles: bubbles ?? true,
			cancelable: cancelable ?? true,
		}));
	}
}));
